<template>
  <div>
    <top-page-header :banners="ads.fv_top_banners ? ads.fv_top_banners : []" />
    <TopRecommendedFeatureEvents />
    <div class="container">
      <div class="container-main marginB8">
        <recommend-event-sale v-if="shouldShowRecommendSale" />
        <div v-if="!loadedRecommendEvent || recommendEventsNew.length > 0" class="ab-issue5090-ph3">
          <scroll-event-list
            :event-list-title="scrollEventListTitle"
            :events="recommendEventsNew"
            :recommend-version="recommendVersionNew"
            :bookmarked-user-count="bookmarkedUserCount"
            use-opix="opixAPIRecommendEventsNew"
            @plus-bookmark-count="applyChangeBookmarkCount(1)"
            @minus-bookmark-count="applyChangeBookmarkCount(-1)"
          />
        </div>
        <recommend-events-personalized />
        <!-- recent checked events -->
        <recent-checked-events :display-limit="10" class="opixRecentCheckedEvents" @click-recent-checked-events="sendOpixClickDatas" />
        <!-- Attention events -->
        <attention-events
          v-if="ads.attention_events && ads.attention_events.length > 0"
          :events="ads.attention_events"
          class="opixAttentionEvents marginT6 commonMargin attentionEventCard"
          @click-attention-event="sendOpixClickDatas"
        />
        <template v-if="$store.isLoggedIn">
          <!-- rankings -->
          <top-sp-ranking
            :prefecture="prefectureRanking"
            class="opixTopSpRanking marginT6 commonMargin rankingCard"
            @click-top-sp-ranking="sendOpixClickDatas"
          />
          <!-- features -->
          <features
            v-if="ads.featured_ads"
            :list="ads.featured_ads"
            :custom-sp-design="true"
            class="opixFeatures marginT6 commonMargin topSp featureCard"
          />
          <!-- Shortcut search by age -->
          <choose-by-age class="opixChooseByAge marginT6 commonMargin topSp" />
        </template>
        <template v-else>
          <!-- Shortcut search by age -->
          <choose-by-age class="opixChooseByAge marginT6 commonMargin topSp" />
          <!-- features -->
          <features
            v-if="ads.featured_ads"
            :list="ads.featured_ads"
            :custom-sp-design="true"
            class="opixFeatures marginT6 commonMargin topSp featureCard"
          />
          <!-- rankings -->
          <top-sp-ranking
            :prefecture="prefectureRanking"
            class="opixTopSpRanking marginT6 commonMargin topSp rankingCard"
            @click-top-sp-ranking="sendOpixClickDatas"
          />
          <!-- for beginner -->
          <for-beginner class="opixForBeginner marginT6 commonMargin topSp" />
          <!-- for participants -->
          <for-participants class="marginT6 commonMargin topSp" />
        </template>
        <public-relations :custom-sp-design="true" class="opixPublicRelations marginT6 commonMargin topSp" />
      </div>
    </div>
  </div>
</template>

<script>
import TrackingUserMixin from '@/utils/mixins/TrackingUserMixin'
import SideContent from '@/utils/mixins/SideContent'
const TopPageHeader = defineAsyncComponent(() => import('@/components/top/TopPageHeader.vue'))
const TopSpRanking = defineAsyncComponent(() => import('@/components/top/TopSpRanking.vue'))
const PublicRelations = defineAsyncComponent(() => import('@/components/banner/PublicRelations.vue'))
const Features = defineAsyncComponent(() => import('@/components/banner/Features.vue'))
const RecentCheckedEvents = defineAsyncComponent(() => import('@/components/RecentCheckedEvents.vue'))
import { OPIX_EVENTS_CHECK_POINTS_ON_TOP_PAGE, OPIX_LOAD_WAIT_TIME } from '@/utils/constants/opixTracking'
import { RECOMMEND_FROM_VIEW_PARTICIPATION_HISTORY, RECOMMEND_HIGH_SATISFACTION } from '@/utils/constants/commons'
import BrowserStorage from '@/utils/BrowserStorage'
import ABTestClientIDService from '@/utils/ABTestClientIDService'
const ScrollEventList = defineAsyncComponent(() => import('@/components/event/ScrollEventList.vue'))
import { buildQueryString } from '@/utils/url-action'
// const RecommendEventsPersonalized = defineAsyncComponent(() => import('@/components/RecommendEventsPersonalized.vue'))
const RecommendEventsPersonalized = defineAsyncComponent(() => import('@/components/RecommendEventsPersonalized.vue'))
import GlobalCookie from '@/utils/GlobalCookie'
const ChooseByAge = defineAsyncComponent(() => import('@/components/top/ChooseByAge.vue'))
const ForBeginner = defineAsyncComponent(() => import('@/components/top/ForBeginner.vue'))
const ForParticipants = defineAsyncComponent(() => import('@/components/top/ForParticipants.vue'))
const AttentionEvents = defineAsyncComponent(() => import('@/components/AttentionEvents.vue'))
const TopRecommendedFeatureEvents = defineAsyncComponent(() => import('@/components/top/TopRecommendedFeatureEvents.vue'))
const RecommendEventSale = defineAsyncComponent(() => import('@/components/RecommendEventSale.vue'))
const RECOMMEND_TYPE_PARTICIPATION_HISTORY = 1
export default {
  components: {
    TopPageHeader,
    Features,
    PublicRelations,
    ForBeginner,
    RecentCheckedEvents,
    TopSpRanking,
    ChooseByAge,
    AttentionEvents,
    RecommendEventsPersonalized,
    ScrollEventList,
    RecommendEventSale,
    ForParticipants,
    TopRecommendedFeatureEvents
  },
  mixins: [TrackingUserMixin, SideContent],
  props: {
    topData: { type: Object, default: () => ({}), required: true },
    ads: { type: Object, default: () => ({}), required: true }
  },
  data() {
    return {
      baseCheckPoints: [...OPIX_EVENTS_CHECK_POINTS_ON_TOP_PAGE],
      regionRankings: null,
      prefectureRanking: null,
      recommendEventsNew: [],
      recommendVersionNew: null,
      recommendTypeNew: null,
      bookmarkedUserCount: 0,
      loadedRecommendEvent: false,
      RECOMMEND_TYPE_PARTICIPATION_HISTORY,
      spTopKeywords: []
    }
  },
  computed: {
    recentCheckedEventIds() {
      const idsString = this.localStorage.getItem('recent_checked_events')
      return idsString ? idsString.split(',') : []
    },
    bookmaredEventIds() {
      const idsString = this.localStorage.getItem('event_bookmarks')
      return idsString ? idsString.split(',') : []
    },
    localStorage() {
      return new BrowserStorage('localStorage')
    },
    scrollEventListTitle() {
      return this.recommendTypeNew === RECOMMEND_TYPE_PARTICIPATION_HISTORY ? RECOMMEND_FROM_VIEW_PARTICIPATION_HISTORY : RECOMMEND_HIGH_SATISFACTION
    },
    /**
     * Showing the component to only 25% of logged-in users
     * @returns {boolean}
     */
    shouldShowRecommendSale() {
      return this.$store.isLoggedIn && ABTestClientIDService.is25PercentPattern(this.$store)
    }
  },
  mounted() {
    this.getRecommendEvents()
    if (!window.opix)
      setTimeout(() => {
        this.sendMJCLFooterDatas('show')
      }, OPIX_LOAD_WAIT_TIME)
    else this.sendMJCLFooterDatas('show')
  },
  created() {
    Object.keys(this.topData).forEach(key => {
      if (!Object.keys(this.$data).includes(key)) return
      this.$data[key] = this.topData[key]
    })
  },
  methods: {
    applyChangeBookmarkCount(num) {
      this.bookmarkedUserCount += num
    },
    getRecommendEvents() {
      const eventIds = this.recentCheckedEventIds.reverse().concat(this.bookmaredEventIds.reverse())
      const globalCookie = new GlobalCookie(this.$store)
      const query = {
        event_ids: eventIds.join(','),
        prefecture: globalCookie.get('prefecture')
      }
      this.$store.dispatch('apiGet', `recommend_events_new/${buildQueryString(query)}`).then(res => {
        this.loadedRecommendEvent = true
        this.recommendEventsNew = res.data.events
        this.recommendVersionNew = res.data.recommend_version
        this.recommendTypeNew = res.data.recommend_type
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  margin-bottom: 0;
}

.container-main {
  width: 96rem;
}

.commonMargin {
  margin-left: $spCommonMargin;
  margin-right: $spCommonMargin;
}

.commonHeadingBlack {
  font-size: 2rem;
  @include pc {
    text-align: center;
    padding-top: 1rem;
    padding-bottom: 1rem;
  }
}

:deep() {
  .commonStyle {
    .clMobileApps,
    .lineFriend {
      margin-left: 0.6rem;
      margin-right: 0.6rem;
    }
  }
  .recentCheckedEvents {
    h2 {
      margin-left: $spCommonMargin;
    }
    .eventsList {
      margin-left: $spCommonMargin;
    }
  }
  .commonHeadingBlack {
    font-size: 2rem;
    @include pc {
      text-align: center;
      padding-top: 1rem;
      padding-bottom: 2rem;
    }
  }
  .commonBlueButtonTop {
    font-size: 1.4rem;
    font-weight: 700;
  }
}

.topSp :deep() {
  .commonHeadingBlack {
    padding-bottom: 1rem;
    @include pc {
      text-align: center;
      padding-top: 1rem;
      padding-bottom: 2rem;
    }
  }
  .bannerList {
    margin-bottom: 4rem;
  }
}

.rankingCard :deep() {
  .contentBox {
    border-radius: 1.2rem;
    padding: 1.5rem;
    box-shadow: 0 0 3px $gray-c6;
  }
  .ticketList-item {
    span {
      border: 0;
    }
  }
  .commonBlueButtonTop {
    color: $gray-55;
  }
}

.featureCard :deep() {
  .contentBox {
    border-radius: 1.2rem;
    padding: 1.5rem;
    box-shadow: 0 0 3px $gray-c6;
    .bannerList {
      margin: 0 0 4rem 0;
    }
    .banners {
      gap: 2rem;
      .bannerList {
        margin: 0;
      }
    }
    .paddingX3 {
      padding: 0;
    }
  }
  .commonBlueButtonTop {
    color: $gray-55;
  }
}

.attentionEventCard {
  .sliderList-item {
    border-radius: 1.2rem;
    padding: 1.5rem;
    box-shadow: 0 0 3px $gray-c6;
    color: $gray-55;
    .sliderList-item-title {
      font-weight: 300;
    }
  }
}
</style>
